import React, { useEffect, useRef, useState } from "react";
import DataTable from 'react-data-table-component';
import { getMensagens } from '../data/api/gsConnectApi';
import { FormatarStrDateParaDDMMYYYYHHMM, FormatarDateParaYYYYMMDD } from '../utils/utils';
import { Container, Row, Col, Form, Button, Alert, Spinner, Card, Badge } from "react-bootstrap";
import { TipoSelect2Component } from "components/select2/tipoSelect2Component";
import { ProfissionaisSelect2Component } from "components/select2/profissionaisSelect2Component";
import { useHistory } from 'react-router-dom';

function EnviosView() {
  const [dataInicio, setDataInicio] = useState(FormatarDateParaYYYYMMDD(new Date(Date.now() - 2592000000)));
  const [dataFim, setDataFim] = useState(FormatarDateParaYYYYMMDD(new Date(Date.now())));
  const [mensagemErro, setMensagemErro] = useState('');
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]);

  const enviadoPorRef = useRef(null);
  const tipoRef = useRef(null);
  const history = useHistory();

  const tableStyles = {
    table: { style: { backgroundColor: '#ffffff', fontSize: '13px' }},
    header: { style: { backgroundColor: '#198754', color: '#fff', fontSize: '16px', fontWeight: '600', paddingLeft: '16px', paddingRight: '16px', minHeight: '48px' }},
    headRow: { style: { backgroundColor: '#e9ecef', minHeight: '40px', borderTopStyle: 'none' }},
    headCells: { style: { fontSize: '13px', fontWeight: '600', color: '#495057', padding: '8px 12px', borderRight: '1px solid #dee2e6', textTransform: 'uppercase', letterSpacing: '0.5px' }},
    rows: { style: { minHeight: '36px', fontSize: '13px', borderBottomWidth: '1px', borderBottomColor: '#dee2e6', '&:hover': { backgroundColor: '#f8f9fa' }, '&:nth-child(even)': { backgroundColor: '#fafafa' }}},
    cells: { style: { padding: '6px 12px', borderRight: '1px solid #dee2e6', fontSize: '13px' }},
    pagination: { style: { borderTop: '1px solid #dee2e6', backgroundColor: '#f8f9fa', fontSize: '13px' }},
  };

  const handlePesquisar = async () => {
    if (!dataInicio) {
      setMensagemErro('Data de início é obrigatória.');
      return;
    }
    if (!dataFim) {
      setMensagemErro('Data final é obrigatória.');
      return;
    }
    if (dataFim < dataInicio) {
      setMensagemErro('Data final deve ser maior que data inicial.');
      return;
    }
    
    setMensagemErro('');
    setLoading(true);

    try {
      const dataInicioCorrecao = new Date(Date.parse(dataInicio) + 86400000);
      const dataFimCorrecao = new Date(Date.parse(dataFim) + 86400000);
      const tipo = (tipoRef.current?.opcaoSelecionada?.value && tipoRef.current?.opcaoSelecionada?.value !== 'SELECIONE') ? tipoRef.current.opcaoSelecionada.value : undefined;
      const idEnviadoPor = (enviadoPorRef.current?.opcaoSelecionada?.value && enviadoPorRef.current?.opcaoSelecionada?.value !== 'SELECIONE') ? enviadoPorRef.current.opcaoSelecionada.value : undefined;

      const mensagens = await getMensagens(tipo, dataInicioCorrecao, dataFimCorrecao, undefined, idEnviadoPor);
      setMessages(Array.isArray(mensagens) ? mensagens : []);
    } catch (error) {
      console.error('Erro ao buscar mensagens:', error);
      setMensagemErro('Erro ao buscar mensagens. Tente novamente.');
      setMessages([]);
    } finally {
      setLoading(false);
    }
  };

  const limparFiltros = () => {
    setDataInicio(FormatarDateParaYYYYMMDD(new Date(Date.now() - 2592000000)));
    setDataFim(FormatarDateParaYYYYMMDD(new Date(Date.now())));
    setMensagemErro('');
    setMessages([]);
    
    try {
      if (enviadoPorRef.current?.opcaoSelecionada) enviadoPorRef.current.opcaoSelecionada = null;
      if (tipoRef.current?.opcaoSelecionada) tipoRef.current.opcaoSelecionada = null;
    } catch (error) {
      console.log('Erro ao limpar selects:', error);
    }
  };

  const renderConteudo = (row) => {
    try {
      if (row.tipo === 'Aniversário' && row.textoSemFormatacao?.includes('data:image')) {
        return <span className="text-primary" style={{fontSize: '13px'}}>🖼️ Imagem</span>;
      }
      if (row.arquivo) {
        return <span className="text-warning" style={{fontSize: '13px'}}>📎 Arquivo</span>;
      }

      const texto = row.texto || row.textoSemFormatacao || 'Sem conteúdo';

      return (
        <div style={{ background: 'linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%)', padding: '8px 12px', borderRadius: '6px', borderLeft: '3px solid #198754', fontSize: '12px', lineHeight: '1.4', wordBreak: 'break-word' }}>
          {texto}
        </div>
      );
    } catch (error) {
      return <span className="text-muted">Erro</span>;
    }
  };

  const getBadgeColor = (tipo) => {
    const colors = { 'Aniversário': 'info', 'Confirmação': 'success', 'Lembrete': 'warning', 'Promocional': 'primary' };
    return colors[tipo] || 'secondary';
  };

  const columns = [
    { 
      name: 'Data *', 
      selector: row => row.criadoEm, 
      sortable: true, 
      width: '140px',
      cell: row => {
        try {
          const dataFormatada = FormatarStrDateParaDDMMYYYYHHMM(row.criadoEm);
          return (
            <span style={{color: '#198754', fontWeight: '500', fontSize: '12px'}}>
              {dataFormatada}
            </span>
          );
        } catch (error) {
          return <span className="text-muted">Data inválida</span>;
        }
      }
    },
    { 
      name: 'Contato', 
      selector: row => row.contato?.nome || 'N/A', 
      sortable: true, 
      width: '180px',
      cell: row => (
        <span style={{fontSize: '13px'}}>
          {row.contato?.nome || 'Não informado'}
        </span>
      )
    },
    { 
      name: 'Tipo', 
      selector: row => row.tipo || 'N/A', 
      sortable: true, 
      width: '120px',
      cell: row => (
        <span style={{fontSize: '12px'}} className={row.tipo ? 'text-dark' : 'text-muted'}>
          {row.tipo || 'N/A'}
        </span>
      )
    },
    { 
      name: 'Conteúdo', 
      selector: row => row.texto, 
      sortable: false,
      wrap: true,
      cell: renderConteudo
    }
  ];

  const calcularEstatisticas = () => {
    try {
      if (!Array.isArray(messages) || messages.length === 0) {
        return { total: 0, contatos: 0, tipos: 0, mediaPorDia: 0 };
      }

      const contatos = new Set();
      const tipos = new Set();

      messages.forEach(msg => {
        if (msg.contato?.nome) contatos.add(msg.contato.nome);
        if (msg.tipo) tipos.add(msg.tipo);
      });

      const diasPeriodo = Math.max(1, Math.ceil((new Date(dataFim) - new Date(dataInicio)) / (1000 * 60 * 60 * 24)));
      const mediaPorDia = Math.round(messages.length / diasPeriodo);

      return { total: messages.length, contatos: contatos.size, tipos: tipos.size, mediaPorDia };
    } catch (error) {
      return { total: 0, contatos: 0, tipos: 0, mediaPorDia: 0 };
    }
  };

  const stats = calcularEstatisticas();

  const statCards = [
    { value: stats.total, label: 'Total de Envios', icon: '📊', color: '#198754' },
    { value: stats.contatos, label: 'Contatos Únicos', icon: '👥', color: '#2e7d32' },
    { value: stats.tipos, label: 'Tipos Diferentes', icon: '🏷️', color: '#388e3c' },
    { value: stats.mediaPorDia, label: 'Média por Dia', icon: '📈', color: '#4caf50' }
  ];

  return (
    <div style={{backgroundColor: '#f8f9fa', minHeight: '100vh'}}>
      {/* Header seguindo padrão gsDoctor */}
      <div style={{backgroundColor: '#198754', color: 'white', padding: '12px 20px', fontSize: '16px', fontWeight: '500'}}>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <Button variant="outline-light" size="sm" style={{borderColor: 'white', color: 'white', marginRight: 12}} onClick={() => history.push('/admin/home')}>
              ← Voltar
            </Button>
            <span>Envios</span>
          </div>
          <Badge bg="primary" className="px-3 py-2">
            {messages.length} {messages.length === 1 ? 'envio' : 'envios'}
          </Badge>
        </div>
      </div>

      <Container fluid className="p-3">
        {/* Alert de erro */}
        {mensagemErro && (
          <Alert variant='danger' className="mb-3" dismissible onClose={() => setMensagemErro('')}>
            {mensagemErro}
          </Alert>
        )}

        {/* Card de Filtros */}
        <div className="bg-white p-3 mb-3" style={{border: '1px solid #dee2e6'}}>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small fw-medium" style={{color: '#198754'}}>Data Início *</Form.Label>
                <Form.Control size="sm" type="date" value={dataInicio} onChange={e => setDataInicio(e.target.value)} style={{fontSize: '13px'}} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small fw-medium" style={{color: '#198754'}}>Data Final *</Form.Label>
                <Form.Control size="sm" type="date" value={dataFim} onChange={e => setDataFim(e.target.value)} style={{fontSize: '13px'}} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small fw-medium text-muted">Profissional</Form.Label>
                <div style={{fontSize: '13px'}}>
                  <ProfissionaisSelect2Component ref={enviadoPorRef} />
                </div>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small fw-medium text-muted">Tipo</Form.Label>
                <div style={{fontSize: '13px'}}>
                  <TipoSelect2Component ref={tipoRef} items={{}} />
                </div>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Button variant="success" size="sm" onClick={handlePesquisar} disabled={loading} className="me-2" style={{backgroundColor: '#198754', borderColor: '#198754', fontSize: '13px', padding: '6px 16px', color: 'white'}}>
                {loading ? (<><Spinner as="span" animation="border" size="sm" className="me-1" />Pesquisando...</>) : 'Pesquisar'}
              </Button>
              <Button variant="outline-secondary" size="sm" onClick={limparFiltros} disabled={loading} style={{fontSize: '13px', padding: '6px 16px'}}>
                Limpar
              </Button>
            </Col>
          </Row>
        </div>

        {/* Cards de Estatísticas - só mostra se tem dados */}
        {messages.length > 0 && (
          <Row className="mb-3">
            {statCards.map((stat, index) => (
              <Col md={3} key={index} className="mb-3">
                <Card className="text-center h-100" style={{backgroundColor: stat.color, color: 'white'}}>
                  <Card.Body className="py-3">
                    <div style={{fontSize: '2rem', marginBottom: '8px'}}>{stat.icon}</div>
                    <h4 className="mb-1">{stat.value}</h4>
                    <small>{stat.label}</small>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}

        {/* DataTable */}
        <div className="bg-white" style={{border: '1px solid #dee2e6'}}>
          <DataTable 
            title="Envios"
            columns={columns}
            data={messages}
            pagination
            paginationPerPage={20}
            paginationRowsPerPageOptions={[10, 20, 50, 100]}
            highlightOnHover
            responsive
            customStyles={tableStyles}
            dense
            noDataComponent={
              <div className="text-center py-4" style={{fontSize: '14px'}}>
                <div className="text-muted mb-2">📭</div>
                <span className="text-muted">
                  {loading ? 'Carregando...' : 'Nenhum registro encontrado'}
                </span>
              </div>
            }
            progressPending={loading}
            progressComponent={
              <div className="text-center py-4">
                <Spinner animation="border" size="sm" />
                <div className="mt-2 text-muted" style={{fontSize: '13px'}}>
                  Carregando dados...
                </div>
              </div>
            }
          />
        </div>
      </Container>
    </div>
  );
}

export default EnviosView;